// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023cfdiweb/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
export const getcode = (phone:any) => {
  return http.get(`${urlPrefix}getcode&phone=${phone}`);
};
export const login = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}login`, qsData);
};
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
export const checkTimes = (phone: any) => {
  return http.get(`${urlPrefix}check-times&phone=${phone}`);
};
export const answerList = (phone: any) => {
  return http.get(`${urlPrefix}answer-list&phone=${phone}`);
};
export const uploadAnswerList = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}answer-upload`, qsData);
};
export const answerUpdate = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}answer-update`, qsData);
};
export const checkIsCommit = (phone: any) => {
  return http.get(`${urlPrefix}check-is-commit&phone=${phone}`);
};
export const getLatest = () => {
  return http.get(`${urlPrefix}get-latest`);
};
export const checkScenenum = (phone: any) => {
  return http.get(`${urlPrefix}check-scenenum&phone=${phone}`);
};

export { getBaseInfo };
